import * as React from "react";
import * as moment from "moment";
import { api, apiOperacao } from "../../api";
import { observer } from "mobx-react";
import { Alert, Button, Classes, Dialog, FileInput, FormGroup, HTMLSelect, InputGroup, Spinner } from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { createViewModel, IViewModel } from "mobx-utils";
import { IContador, IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { ContadorDialogStore } from "../../stores/perfil/ContadorDialogStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { mascara_inscricao_estadual, validarCNPJ } from "../../utils";
import { formatCnpj } from "../../utils";
import LoadingModal from "../loading/LoadingModal";

const BrV = require("br-validations");
const InputMask = require("react-input-mask");

require("../../assets/css/components/EmpresaForm.css");


interface IEmpresaFormProps {
}

@observer
export default class EmpresaCreateForm extends React.Component<IEmpresaFormProps, any> {
  obs = observable({
    focusEl: {} as HTMLElement,
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    nome_certificado: "Selecione o certificado" as string,
    certificado: [] as any,
    handleModalCertTeste: false as boolean,
    handleModalConfirm: false as boolean,
    handleModalConfirmRegime: false as boolean,
    pgdas_invalid: false as boolean,
    validando: false as boolean,
    cod_acesso: "" as string,
    contadores_list: [] as IContador[],
    contador_name: "" as string,
  })

  constructor(props: IEmpresaFormProps) {
    super(props);

    AppStore.setTitle("");
    this.obs.empresa = createViewModel(newEmpresa());
  }

  async componentDidMount() {
    if (EmpresaStore.obs.cnpj == "") {
      return AppStore.setLocation("/empresa/plan");
    }
    this.obs.focusEl.focus();
    EmpresaStore.obs.working = false;

    await ContadorDialogStore.handleGetContadores();

    this.obs.contadores_list = ContadorDialogStore.obs.contadores_list;

    this.obs.empresa = createViewModel(newEmpresa());

    this.setState({ filial: "" });

    this.forceUpdate();

    this.obs.empresa.simples_nacional = null;
    this.obs.empresa.regime_especial_icms_pa = null;
    this.obs.empresa.convenio_icms_100_97 = null;
    this.obs.empresa.medicamento_uso_veterinario = null;
    this.obs.empresa.auto_pecas = null;
    this.obs.empresa.porta_a_porta = null;

    this.setState({ filial: EmpresaStore.obs.filial });

    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let totalEmpresas = EmpresaStore.obs.count_empresas

    if (contaPermissao && totalEmpresas > 1) {
      return AppStore.setLocation("/empresas");
    }
  }

  handleCheckFilial = (filial: any) => {
    let fil;
    if (filial == "true") {
      fil = true;
    } else {
      fil = false;
    }
    this.setState({ filial: fil });
    this.obs.empresa.filial = fil;
    EmpresaStore.obs.filial = fil;
  };

  handleCheckRegime = (regime: any) => {
    EmpresaStore.obs.regime_importacao = regime.target.value;
    this.obs.handleModalConfirmRegime = true;
  };

  async handleImportCertificado() {

    try {

      let senha: string = this.obs.empresa.senha_certificado
      let cnpj: string = EmpresaStore.obs.cnpj
      let filial: boolean = EmpresaStore.obs.filial
      let certificado: any = this.obs.certificado[0]

      var data = new FormData();
      data.append("filial", filial.toString());
      data.append("file", certificado);
      data.append("senha", senha);
      data.append("cnpj", cnpj);

      let resp = await apiOperacao("empresas").post("/empresas/upload-certificado", data)

      if (resp.data.ok) {

        toast.success('Certificado importado com sucesso', {});

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (e){}

  }

  handleConfirm = () => {
    this.obs.handleModalConfirm = true;
  };

  handleSave = async () => {
    let razao_social = (document.getElementById("razao-social") as HTMLInputElement).value;
    EmpresaStore.obs.razao_social = razao_social;
    let nome_fantasia = (document.getElementById("nome-fantasia") as HTMLInputElement).value;
    EmpresaStore.obs.nome_fantasia = nome_fantasia;

    let simples = EmpresaStore.obs.simples_nacional;

    var tribut1 = (document.getElementById("TributacaoSelect1") as HTMLInputElement).value;
    var tribut2 = (document.getElementById("TributacaoSelect2") as HTMLInputElement).value;
    var tribut3 = (document.getElementById("TributacaoSelect3") as HTMLInputElement).value;
    var tribut4 = (document.getElementById("TributacaoSelect4") as HTMLInputElement).value;
    var tribut5 = (document.getElementById("TributacaoSelect5") as HTMLInputElement).value;
    var tribut7 = (document.getElementById("TributacaoSelect7") as HTMLInputElement).value;

    if (!EmpresaStore.obs.cnpj) {
      toast.error('Preencha o campo CNPJ', {});
      return;
    }
    if (!validarCNPJ(EmpresaStore.obs.cnpj)) {
      toast.error('CNPJ inválido', {});
      return;
    }
    if (!EmpresaStore.obs.razao_social) {
      toast.error('Preencha o campo Razão social', {});
      return;
    }

    if (!EmpresaStore.obs.nome_fantasia) {
      toast.error('Preencha o campo Nome Fantasia', {});
      return;
    }

    if (EmpresaStore.obs.inscricao_estadual != "") {

      let inscricaoEstadual = (EmpresaStore.obs.inscricao_estadual?.replace(/[^0-9]/g, '')).toString()

      // if (!BrV.ie(EmpresaStore.obs.empresa.uf).validate(inscricaoEstadual)) {
      //   toast.warning('Inscrição Estadual Inválida', {});
      //   return;
      // }

      EmpresaStore.obs.inscricao_estadual = inscricaoEstadual;

    }

    if (!EmpresaStore.obs.regime_importacao) {
      toast.error('Selecione o regime da Empresa', {});
      return;
    }

    if (simples == null) {
      toast.error('Selecione se a empresa é simples ou de regime normal', {});
      return;
    } else if (!simples) {
      this.obs.empresa.plano = "normal";
    } else {
      this.obs.empresa.plano = "simples";
    }
    if (!this.obs.empresa.plano) {
      toast.error('Selecione um plano para essa empresa', {});
      return;
    }

    if (tribut1 == "Selecione" || tribut2 == "Selecione" || tribut3 == "Selecione" || tribut4 == "Selecione" || tribut5 == "Selecione" || tribut7 == "Selecione") {
      toast.error('Selecione as Tributações da Empresa', {});
      return;
    }

    if (this.state.filial == true) {
      this.obs.empresa.filial = true;
    } else {
      this.obs.empresa.filial = false;
    }

    this.obs.empresa.plano_id = EmpresaStore.obs.valorPlano;

    this.doSave();
  };

  handleSetContador(id: string) {
    for (let i = 0; i < this.obs.contadores_list.length; i++) {
      if (this.obs.contadores_list[i].id == id) {
        this.obs.empresa.contador_responsavel = this.obs.contadores_list[i].id;
        this.obs.contador_name = this.obs.contadores_list[i].nome;
      }
    }
  }

  doSave = async () => {

    if (this.obs.certificado.length > 0) {

      if (this.obs.empresa.senha_certificado == "") {
        toast.error('Preencha a senha do certificado', {});
        return;
      }

    }

    try {

      let isCreated = await EmpresaStore.createEmpresa(this.obs.empresa);

      if (isCreated) {

        if (this.obs.certificado.length > 0) {

          this.handleImportCertificado();

        }

        setTimeout(() => { AppStore.setLocation("/empresas"); window.location.reload(); }, 1000);

      }

    } catch (ex) {

      toast.error(String(ex), {});

    }

    EmpresaStore.setWorking(false);

  };

  handleCancel = () => {
    window.location.href = "/empresa/plan"
  };

  checkSimples(e: any) {
    if (e.target.value == 1) {
      EmpresaStore.obs.simples_nacional = !!e.target.value;
      EmpresaStore.obs.regime_especial_icms_pa = false;
    } else {
      EmpresaStore.obs.simples_nacional = !!e.target.value;
    }
  }

  handleConfirmRegime = async () => {

    this.obs.handleModalConfirmRegime = false;

    let resp = await apiOperacao("empresas").get(`/empresas/confirmar-regime-empresa`);

  };

  handleCancelRegime = () => {
    this.obs.handleModalConfirmRegime = false;
    EmpresaStore.obs.regime_importacao = "";
  };

  render() {
    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    const handleFileInputChange = (event) => {
      const file = event.target.files[0];

      this.obs.nome_certificado = file.name
      this.obs.certificado = event.target.files

    };

    return (
      <>
        <LoadingModal open={this.obs.validando} onClose={() => this.obs.validando = false} title={"Validando PGDAS"} />

        <Dialog
          isOpen={this.obs.handleModalConfirmRegime}
          title="Atenção"
          onClose={() => this.handleCancelRegime()}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Regime Selecionado: {EmpresaStore.obs.regime_importacao}
                </h3>
                <h3 className="titleProccess">
                  O regime selecionado irá impactar o resultado dos cálculos
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Certifique-se que realmente este é o regime da sua empresa.
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>
            <Button
              onClick={() => this.handleCancelRegime()}
              className="cancelCadEmp"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => this.handleConfirmRegime()}
              className="certiDigitalTeste"
            >
              Sim, este é o Regime
            </Button>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.obs.handleModalConfirm}
          title="Confirme os dados e conclua o cadastro"
          onClose={() => this.obs.handleModalConfirm = false}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="6">
                <h3 className="titleProccess">Dados da Empresa</h3>
                <p><b>CNPJ:</b> {EmpresaStore.obs.cnpj}</p>
                <p><b>Razão Social:</b> {EmpresaStore.obs.razao_social}</p>
                <p><b>Nome Fantasia:</b> {EmpresaStore.obs.nome_fantasia}</p>
                <p><b>Inscrição Estadual:</b> {EmpresaStore.obs.inscricao_estadual}</p>
                <p><b>Tipo de Cadastro:</b>{" "}{EmpresaStore.obs.filial ? "FILIAL" : "MATRIZ"}</p>
                <p><b>Regime da Empresa:</b> {EmpresaStore.obs.regime_importacao}</p>
                <p><b>Municipio:</b> {EmpresaStore.obs.empresa.municipio}</p>
                <p><b>Estado:</b> {EmpresaStore.obs.empresa.uf}</p>
              </MDBCol>
              <MDBCol md="6">
                <h3 className="titleProccess">Tributações</h3>
                <p><b>Regime Simples Nacional:</b>{" "}{EmpresaStore.obs.simples_nacional ? "Sim" : "Não"}</p>
                <p><b>Excesso de Sublimite de Receita Bruta:</b>{" "}{EmpresaStore.obs.simples_nacional_excesso ? "Sim" : "Não"}</p>
                <p><b>Regime Especial:</b>{" "}{EmpresaStore.obs.regime_especial_icms_pa ? "Sim" : "Não"}</p>
                <p><b>Convênio ICMS 100/97:</b>{" "}{EmpresaStore.obs.convenio_icms_100_97 ? "Sim" : "Não"}</p>
                <p><b>Comercializa Medicamentos Veterinários, PET.:</b>{" "}{EmpresaStore.obs.medicamento_uso_veterinario ? "Sim" : "Não"}</p>
                <p><b>Comercializa Produtos Auto Peças:</b> {EmpresaStore.obs.auto_pecas ? "Sim" : "Não"}</p>
                <p><b>Operação de Venda na Modalidade Porta a Porta:</b> {EmpresaStore.obs.porta_a_porta ? "Sim" : "Não"}</p>

              </MDBCol>
            </MDBRow>
            <Button
              onClick={() => this.obs.handleModalConfirm = false}
              className="cancelCadEmp"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.handleSave}
              className="certiDigitalTeste"
              loading={EmpresaStore.obs.working}
            >
              Concluir Cadastro
            </Button>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.obs.handleModalCertTeste}
          title="Certificado Digital"
          onClose={() => this.obs.handleModalCertTeste = false}
          style={{ width: 700 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <br />
            <br />
            <div className="icon-warning-dialog">
              <img src="/images/calendar.svg" width="120px;" />
            </div>
            <h3 className="titleProccess">
              Com o certificado digital cadastrado, você ganha inúmeros
              benefícios.
            </h3>
            <p>
              Tendo o Certificado Digital em mãos, A FIPO dispobiliza o módulo
              {" "}
              <b>Manifestação de NF-es</b>
            </p>
            <p style={{ lineHeight: "24px" }}>
              Com ele, sincronizamos os dados da sua empresa em conjunto com a
              Secretaria da Fazenda <br />
              através dos webservices oficiais disponibilizados pelo governo,
              que permitem a consulta,<br /> monitoramento e download de
              <b>NF-es</b> sem depender de chave de acesso e com a{" "}
              <br />segurança de receber todos os documentos.
            </p>
            <br />
            <p>
              <b>* Módulo não disponível em período de teste.</b>
            </p>
            <Button
              onClick={(e) => AppStore.setLocation("/historico-notas")}
              className="certiDigitalTeste"
            >
              Veja uma Demonstração
            </Button>
          </div>
        </Dialog>

        <div className="empresa-form empresa-steps">
          <MDBRow>
            <div className="dados-empresa">
              <div className="form-step">
                <h2 className="title">Dados da Empresa</h2>
                {!["RS", "PA"].includes(EmpresaStore.obs.empresa.uf) &&
                  <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
                    Para o estado atual {EmpresaStore.obs.empresa.uf}, o FIPO fornece apenas os serviços de manifestação de NFe, CTe e NFCe, pois não atendemos este estado nos demais serviços. Para ter todos os serviços funcionando, é necessário estar no estado do PA ou RS.
                  </p>
                }
                <div style={{ display: "flex" }} className="mini-selects">
                  <FormGroup
                    label="CNPJ"
                    labelFor="cnpj"
                    style={{ width: "100%" }}
                    labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                  >
                    <InputGroup
                      disabled
                      value={formatCnpj(EmpresaStore.obs.cnpj)}
                    />
                  </FormGroup>
                </div>
                <FormGroup
                  label="Razão social"
                  labelFor="razao-social"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <InputGroup
                    id="razao-social"
                    inputRef={el => this.obs.focusEl = el}
                    defaultValue={EmpresaStore.obs.razao_social}
                    onChange={(e: any) =>
                      EmpresaStore.obs.razao_social = e.target.value}
                  />
                </FormGroup>

                <FormGroup
                  label="Nome fantasia"
                  labelFor="nome-fantasia"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <InputGroup
                    id="nome-fantasia"
                    inputRef={el => this.obs.focusEl = el}
                    defaultValue={EmpresaStore.obs.nome_fantasia}
                    onChange={(e: any) =>
                      EmpresaStore.obs.nome_fantasia = e.target.value}
                  />
                </FormGroup>

                <FormGroup
                  label="Inscrição Estadual"
                  labelFor="inscricao-estadual"
                >
                  {["RS", "SP", "MG", "PA"].includes(EmpresaStore.obs.empresa.uf) ?
                    <InputMask
                      className="form-control"
                      mask={mascara_inscricao_estadual(EmpresaStore.obs.empresa.uf)}
                      value={EmpresaStore.obs.inscricao_estadual}
                      onChange={(e: any) => EmpresaStore.obs.inscricao_estadual = e.target.value}
                    />
                    :
                    <InputGroup
                      id="inscricao-estadual"
                      value={EmpresaStore.obs.inscricao_estadual}
                      onChange={(e: any) => EmpresaStore.obs.inscricao_estadual = e.target.value}
                    />
                  }
                </FormGroup>

                {!is_teste &&
                  <FormGroup
                    label="Contador Responsável"
                    labelFor="contador"
                    style={{ width: "100%", float: "left" }}
                  >
                    <HTMLSelect
                      onChange={(e) => this.handleSetContador(e.target.value)}
                    >
                      <option value={this.obs.empresa.contador_responsavel} selected>
                        {this.obs.contador_name}
                      </option>
                      {this.obs.contadores_list?.map((el, index) => {
                        return (
                          <option id={index.toString()} value={el.id}>
                            {el.nome}
                          </option>
                        );
                      })}
                    </HTMLSelect>

                    {!this.obs.contadores_list.length &&
                      (
                        <span>
                          Você pecisar acessar o perfil e cadastrar um{" "}
                          <b>Contador</b>
                        </span>
                      )}
                  </FormGroup>

                }

                <FormGroup
                  label="Regime da Empresa"
                  labelFor="regime"
                  style={{ width: "58%", float: "left" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect
                    onChange={this.handleCheckRegime.bind(this)}
                    id="regime"
                  >
                    <option value="">SELECIONE</option>
                    <option value="CAIXA">CAIXA</option>
                    <option value="COMPETÊNCIA">COMPETÊNCIA</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Tipo de Cadastro"
                  labelFor="tipo"
                  style={{ width: "38%", float: "right" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect
                    onChange={(e) => this.handleCheckFilial(e.target.value)}
                    id="TipoEmpresa"
                    disabled
                  >
                    <option value="">Selecione</option>
                    <option value="false" selected={!EmpresaStore.obs.filial}>MATRIZ</option>
                    <option value="true" selected={EmpresaStore.obs.filial}>FILIAL</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Município"
                  labelFor="municipio"
                  style={{ width: "58%", float: "left" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect disabled id="municipio">
                    <option selected value={EmpresaStore.obs.empresa.municipio}>{EmpresaStore.obs.empresa.municipio}</option>
                  </HTMLSelect>
                </FormGroup>


                <FormGroup
                  label="Estado"
                  labelFor="estado"
                  style={{ width: "38%", float: "right" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect disabled id="estado">
                    <option selected value={EmpresaStore.obs.empresa.uf}>{EmpresaStore.obs.empresa.uf}</option>
                  </HTMLSelect>
                </FormGroup>

              </div>
            </div>

            {EmpresaStore.obs.empresa.uf != "RS" ?
              <div className="dados-tributacoes">
                <MDBRow>
                  <MDBCol md="12">
                    <div className="form-step">
                      <h2 className="title">Tributações de Entrada</h2>
                      <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
                        Atenção! É importante você selecionar as informações
                        corretas das tributações, pois elas interferem diretamente
                        no cálculo.
                      </p>
                      <FormGroup
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                        label="Regime Simples Nacional">
                        <HTMLSelect
                          onChange={e => this.checkSimples(e)}
                          id="TributacaoSelect1"
                          required
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      {EmpresaStore.obs.simples_nacional == true &&
                        <FormGroup
                          labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                          label="Excesso de Sublimite de Receita Bruta">
                          <HTMLSelect
                            onChange={e => { EmpresaStore.obs.simples_nacional_excesso = !!e.target.value }}
                            id="TributacaoSelect6"
                          >
                            <option value="Selecione" selected>Selecione</option>
                            <option value="">Não</option>
                            <option value="1">Sim</option>
                          </HTMLSelect>
                        </FormGroup>

                      }
                      <FormGroup
                        label="Regime Especial"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.regime_especial_icms_pa = !!e.target.value }}
                          id="TributacaoSelect2"
                          disabled={EmpresaStore.obs.simples_nacional}
                        >
                          <option value="Selecione" selected={EmpresaStore.obs.simples_nacional ? false : true}>Selecione</option>
                          <option value="" selected={EmpresaStore.obs.simples_nacional ? true : false}>Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Convênio ICMS 100/97"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.convenio_icms_100_97 = !!e.target.value }}
                          id="TributacaoSelect3"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Comercializa Medicamentos Veterinários, PET."
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.medicamento_uso_veterinario = !!e.target.value }}
                          id="TributacaoSelect4"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Comercializa Produtos Auto Peças"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.auto_pecas = !!e.target.value }}
                          id="TributacaoSelect5"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Operação de Venda na Modalidade Porta a Porta"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.porta_a_porta = !!e.target.value }}
                          id="TributacaoSelect7"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                    </div>
                  </MDBCol>
                </MDBRow>
              </div>
              :
              <div className="dados-tributacoes">
                <MDBRow>
                  <MDBCol md="12">
                    <div className="form-step">
                      <h2 className="title">Tributações de Entrada</h2>
                      <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
                        Atenção! É importante você selecionar as informações
                        corretas das tributações, pois elas interferem diretamente
                        no cálculo.
                      </p>
                      <FormGroup
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                        label="Regime Simples Nacional">
                        <HTMLSelect
                          onChange={e => this.checkSimples(e)}
                          id="TributacaoSelect1"
                          required
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      {EmpresaStore.obs.simples_nacional == true &&
                        <FormGroup
                          labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                          label="Excesso de Sublimite de Receita Bruta">
                          <HTMLSelect
                            onChange={e => { EmpresaStore.obs.simples_nacional_excesso = !!e.target.value }}
                            id="TributacaoSelect6"
                          >
                            <option value="Selecione" selected>Selecione</option>
                            <option value="">Não</option>
                            <option value="1">Sim</option>
                          </HTMLSelect>
                        </FormGroup>

                      }
                      <FormGroup
                        label="Regime Especial"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.regime_especial_icms_pa = !!e.target.value }}
                          id="TributacaoSelect2"
                          disabled={EmpresaStore.obs.simples_nacional}
                        >
                          <option value="Selecione" selected={EmpresaStore.obs.simples_nacional ? false : true}>Selecione</option>
                          <option value="" selected={EmpresaStore.obs.simples_nacional ? true : false}>Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Convênio ICMS 100/97"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.convenio_icms_100_97 = !!e.target.value }}
                          id="TributacaoSelect3"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Comercializa Medicamentos Veterinários, PET."
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.medicamento_uso_veterinario = !!e.target.value }}
                          id="TributacaoSelect4"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Comercializa Produtos Auto Peças"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.auto_pecas = !!e.target.value }}
                          id="TributacaoSelect5"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                      <FormGroup
                        label="Operação de Venda na Modalidade Porta a Porta"
                        labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                        <HTMLSelect
                          onChange={e => { EmpresaStore.obs.porta_a_porta = !!e.target.value }}
                          id="TributacaoSelect7"
                        >
                          <option value="Selecione" selected>Selecione</option>
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </HTMLSelect>
                      </FormGroup>

                    </div>
                    <div style={{ float: "right" }} className="nz-button-panel">
                      <Button
                        text="Cancelar"
                        onClick={this.handleCancel}
                        className="btnCancelEmp"
                        disabled={EmpresaStore.obs.working}
                      />
                      &nbsp;&nbsp;
                      <Button
                        text="Cadastrar Empresa"
                        onClick={this.handleConfirm}
                        className="btnCadastraEmp"
                        loading={EmpresaStore.obs.working}
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>
            }

            {EmpresaStore.obs.empresa.uf != "RS" &&
              <div className="dados-certificado">

                <div className="form-step">
                  <h2 className="title">Certificado Digital (A1)</h2>
                  <FormGroup label="Selecionar Certificado Digital" labelFor="certificado">
                    <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={handleFileInputChange} />
                  </FormGroup>

                  <FormGroup label="Senha Certificado">
                    <InputGroup type="password" onChange={(e: any) => this.obs.empresa.senha_certificado = e.target.value} />
                  </FormGroup>
                </div>

                <Button
                  text="Cancelar"
                  onClick={this.handleCancel}
                  className="btnCancelEmp"
                  disabled={EmpresaStore.obs.working}
                />
                &nbsp;&nbsp;
                <Button
                  text="Cadastrar Empresa"
                  onClick={this.handleConfirm}
                  className="btnCadastraEmp"
                  loading={EmpresaStore.obs.working}
                />

              </div>
            }
          </MDBRow>
        </div>
      </>
    );
  }
}
